module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper--pageform"
  }, [_c('div', {
    staticClass: "mt-5"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.title),
      expression: "value.title"
    }],
    staticClass: "form-control form__text",
    attrs: {
      "type": "text",
      "name": "title",
      "id": "page-title",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.value.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors['value.title'].empty),
      expression: "$v.$errors['value.title'].empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกชื่อกองผ้าป่า")])]), _vm._v(" "), _c('div', {
    staticClass: "mt-5"
  }, [_vm._m(1), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.message),
      expression: "value.message"
    }],
    staticClass: "form__textarea",
    attrs: {
      "id": "page-message",
      "placeholder": "กองผ้าป่านี้เพื่อน้องๆ ได้มีโอกาสทางการศึกษา มาช่วยกันนะ",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.value.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "message", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-remark text-right mt--15",
    class: {
      error: _vm.overMaxLength
    }
  }, [_vm._v(_vm._s(_vm.value.message.length) + "/" + _vm._s(_vm.maxMessageLength))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors['value.message'].maxLength),
      expression: "$v.$errors['value.message'].maxLength"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("จำนวนข้อความต้องไม่เกิน " + _vm._s(_vm.maxMessageLength) + " ตัวอักษร")])]), _vm._v(" "), _c('div', {
    staticClass: "mt-5 mb-20"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.owner),
      expression: "value.owner"
    }],
    staticClass: "form__text",
    attrs: {
      "type": "text",
      "name": "owner",
      "id": "page-owner",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.value.owner)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "owner", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form__item form__item--inline"
  }, [_c('label', {
    staticClass: "form__label form__label--title"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.type),
      expression: "value.type"
    }],
    staticClass: "form__input",
    attrs: {
      "type": "radio",
      "name": "type",
      "value": "1",
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": _vm._q(_vm.value.type, "1")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.value, "type", "1")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon _sl-tcfe"
  }, [_vm._v(" ")]), _vm._v("สร้างกองผ้าป่าร้อยพลังการศึกษา\n    ")])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "form__item form__item--inline"
  }, [_c('label', {
    staticClass: "form__label form__label--title"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.type),
      expression: "value.type"
    }],
    staticClass: "form__input",
    attrs: {
      "type": "radio",
      "name": "type",
      "value": "3",
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": _vm._q(_vm.value.type, "3")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.value, "type", "3")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon _sl-school"
  }, [_vm._v(" ")]), _vm._v("สร้างกองผ้าป่าให้โรงเรียน\n    ")]), _vm._v(" "), (_vm.value.type === '3') ? _c('div', {
    staticClass: "form__sub-section"
  }, [_c('div', {
    staticClass: "form__select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.province2),
      expression: "province2"
    }],
    attrs: {
      "id": "page-province2",
      "disabled": _vm.disabled
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.province2 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.selectProvince]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("- เลือกจังหวัด -")]), _vm._v(" "), _vm._l((_vm.provinces), function(province) {
    return _c('option', {
      domProps: {
        "value": province.id
      }
    }, [_vm._v(_vm._s(province.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors['province2'].empty),
      expression: "$v.$errors['province2'].empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณาเลือกจังหวัด")]), _vm._v(" "), (_vm.value.type === '3') ? _c('div', {
    staticClass: "form__select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.school),
      expression: "value.school"
    }],
    attrs: {
      "id": "page-school",
      "disabled": _vm.disabled
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.value, "school", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("- เลือกโรงเรียน -")]), _vm._v(" "), _vm._l((_vm.schools), function(school) {
    return _c('option', {
      domProps: {
        "value": school.id
      }
    }, [_vm._v(_vm._s(school.name))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors['value.school'].empty),
      expression: "$v.$errors['value.school'].empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณาเลือกโรงเรียน")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form__item form__item--inline"
  }, [_c('label', {
    staticClass: "form__label form__label--title"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.type),
      expression: "value.type"
    }],
    staticClass: "form__input",
    attrs: {
      "type": "radio",
      "name": "type",
      "value": "2",
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": _vm._q(_vm.value.type, "2")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.value, "type", "2")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon _sl-province"
  }, [_vm._v(" ")]), _vm._v("สร้างกองผ้าป่าให้จังหวัด\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "form__sub-section"
  }, [(_vm.value.type === '2') ? _c('div', {
    staticClass: "form__select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.province),
      expression: "province"
    }],
    attrs: {
      "id": "page-province",
      "disabled": _vm.disabled
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.province = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.selectProvince]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("- เลือกจังหวัด -")]), _vm._v(" "), _vm._l((_vm.provinces), function(province) {
    return _c('option', {
      domProps: {
        "value": province.id
      }
    }, [_vm._v(_vm._s(province.name))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors['province'].empty),
      expression: "$v.$errors['province'].empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณาเลือกจังหวัด")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors['value.type'].empty),
      expression: "$v.$errors['value.type'].empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณาเลือกประเภทการบริจาค")]), _vm._v(" "), _c('div', {
    staticClass: "_clearfix mt-15"
  }, [_c('div', {
    staticClass: "fl-right"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.submitButtonText))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "page-title"
    }
  }, [_c('span', {
    staticClass: "ic-label"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/icon/phapa@2x.png"),
      "width": "25px"
    }
  })]), _vm._v("ตั้งชื่อกองผ้าป่า")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "page-message"
    }
  }, [_c('span', {
    staticClass: "ic-label"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/icon/message@2x.png"),
      "width": "25px"
    }
  })]), _vm._v("ข้อความเชิญชวน")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "page-owner"
    }
  }, [_c('span', {
    staticClass: "ic-label"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/icon/person@2x.png"),
      "width": "25px"
    }
  })]), _vm._v("ชื่อ-นามสกุลเจ้าของกองผ้าป่า")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-remark"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("หรือเลือกประเภทกองผ้าป่า")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-617bb974","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageForm.vue
// module id = 1138
// module chunks = 1